import type { GlobalFilter } from '@hotjar/global-filters';
import { FilterKindEnum, DATE_RANGE_TYPE } from '@hotjar/global-filters';
import { getEventTriggeredOnState } from '@hotjar/heatmaps';
import { tagRecording } from '@hotjar/webapp/tracking/tools/hotjar';
import { ProductType } from '@hotjar/webapp/domains/common/product/types';
import {
  MAX_DATA_RETENTION_PERIOD,
  StatefulFilterChain,
} from '@hotjar/webapp/features/GlobalFilterChain/StatefulComponent/StatefulFilterChain';
import type { PlanComparisonReferrer } from '@hotjar/webapp/features/Billing/PlanComparisonModal/types';

const SUPPORTED_FILTER_LIST: Set<FilterKindEnum> = new Set([
  FilterKindEnum.Error,
  FilterKindEnum.Clicked,
  FilterKindEnum.VisitedURL,
  FilterKindEnum.ReferrerURL,
  FilterKindEnum.LandingURL,
  FilterKindEnum.ExitURL,
  FilterKindEnum.NewReturningUserKind,
  FilterKindEnum.Country,
  FilterKindEnum.Event,
  FilterKindEnum.GoogleOptimize,
  FilterKindEnum.Optimizely,
  FilterKindEnum.Unbounce,
  FilterKindEnum.UserAttribute,
  FilterKindEnum.SessionDuration,
  FilterKindEnum.PageCount,
  FilterKindEnum.RageClickKind,
  FilterKindEnum.UTurnKind,
  FilterKindEnum.UserID,
  // FilterKindEnum.DeviceType, TODO: To be revisited when we do AT-1843
  FilterKindEnum.Browser,
  FilterKindEnum.OS,
  FilterKindEnum.IncomingFeedback,
  FilterKindEnum.NPS,
]);

export type HeatmapFilterChainProps = {
  selectedFiltersInUiFormat: GlobalFilter;
  onFiltersChange: (filtersInUiFormat: GlobalFilter, segmentId?: number) => void;
  onUpsellRequest: (
    featureName: PlanComparisonReferrer,
    additionalTrackingData?: Record<string, string>,
  ) => void;
};

export const HeatmapFilterChain = ({
  selectedFiltersInUiFormat,
  onFiltersChange,
  onUpsellRequest,
}: HeatmapFilterChainProps): JSX.Element => {
  const handleOptionSelect = (filtersInUiFormat: GlobalFilter) => {
    if (filtersInUiFormat?.dateRange?.type === DATE_RANGE_TYPE.ABSOLUTE) {
      tagRecording('CH Date Ranges Used');
    }

    onFiltersChange(filtersInUiFormat);
  };

  return (
    <StatefulFilterChain
      currentFiltersInUiFormat={selectedFiltersInUiFormat}
      onChange={handleOptionSelect}
      onUpsellRequest={(featureName) =>
        onUpsellRequest(featureName as PlanComparisonReferrer, getEventTriggeredOnState())
      }
      hideSaveSegment
      supportedFilterList={SUPPORTED_FILTER_LIST}
      dateConstraint={MAX_DATA_RETENTION_PERIOD}
      contextOfUse={{
        productType: ProductType.Analytics,
        page: 'heatmap.report',
        toolName: 'Heatmaps',
      }}
    />
  );
};
